// TLoading.js
import { Loading } from 'element-ui';

class TLoading {
	constructor() {
		this.loadingInstance = null;
	}

	//重置
	static reset() {
		this.loadingInstance = null;
	}

	// 开启全屏加载
	static start(options = {}) {
		return Loading.service({
			lock: true,
			text: '加载中...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)',
			...options
		});
	}

		// 开启全屏加载
	static startBgWhite(options = {}) {
		return Loading.service({
			lock: true,
			text: '加载中...',
			spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255,.5)',
			...options
		});
	}

	// 关闭加载
	static close(loadingInstance) {
		if (loadingInstance) {
			loadingInstance.close();
		}
	}

	// 开启指定区域加载
	static startForElement(element, options = {}) {
		this.loadingInstance = Loading.service({
			target: element,
			text: '加载中...',
			spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255,.9)',
			...options
		});
		return this.loadingInstance;
	}

	// 快速显示加载（简化版）
	static show(text = '加载中...', options = {}) {
		return this.start({
			text,
			...options
		});
	}

	// 显示文字加载提示
	static showText(text, options = {}) {
		return this.start({
			text,
			background: 'rgba(255, 255, 255,.9)',
			...options
		});
	}

	// 实例方法开启加载
	static startInstance(options = {}) {
		this.loadingInstance = Loading.service({
			lock: true,
			text: '加载中...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)',
			...options
		});
		return this.loadingInstance;
	}

	// 实例方法关闭加载
	static closeInstance() {
		if (this.loadingInstance) {
			this.loadingInstance.close();
			this.loadingInstance = null;
		}
	}
}

export default TLoading;

// 使用说明
// 在组件中使用
// import TLoading from '@/utils/TLoading'
//
// // 全屏加载
// const loadingInstance = TLoading.start()
//
// // 指定时间后关闭
// setTimeout(() => {
//     TLoading.close(loadingInstance)
// }, 2000)
//
// // 指定区域加载
// const elementLoading = TLoading.startForElement('.my-container')
//
// // 关闭指定加载
// TLoading.close(elementLoading)
//
// // 快速显示加载
// const quickLoading = TLoading.show('正在处理...')
//
// // 自定义文本加载
// const textLoading = TLoading.showText('数据加载中，请稍候...')
